import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-73241e11"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detail" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = { class: "more" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Everyone is Different."),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("Sixliv's "),
    /*#__PURE__*/_createElementVNode("span", { class: "hightText" }, "AI-Enhanced")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "Personalised Care."),
  /*#__PURE__*/_createElementVNode("p", null, "Feel Better, Live Happier")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dec" }, " At Sixliv, we handle your clinic operations 24/7, so you can focus on exceptional care. Our AI innovative healthcare solutions, based on lifestyle medicine, prioritise patients' overall well-being. We streamline operations, enhance engagement, and improve outcomes ", -1))
const _hoisted_6 = { class: "pic" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "tabs" }

import {onMounted, reactive, ref, watchEffect} from "vue";
import Business from "./Business.vue";
import Treated from "./Treated.vue";
import { useData } from "@/utils/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'Detail',
  setup(__props) {

const pageData=useData()

const tabRef = ref("tab1");
const pageTopPic = reactive({
  url: "",
  tabs: [],
});
const handleChangeTab = (tab: string) => {
  tabRef.value = tab;
};
watchEffect(() => {
  const {PAGE_TOP,FUN_ZONE}=pageData.globalData.value
  if(PAGE_TOP){
    pageTopPic.url=PAGE_TOP.url
  }
  if(FUN_ZONE){
    pageTopPic.tabs=FUN_ZONE
  }
})
onMounted(() => {
  if (localStorage.getItem("PAGE_TOP")) {
    pageTopPic.url = JSON.parse(localStorage.getItem("PAGE_TOP") || "").url || "";
    if (localStorage.getItem("FUN_ZONE")) {
      pageTopPic.tabs = JSON.parse(localStorage.getItem("FUN_ZONE") || "");
    }
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createVNode(_component_router_link, {
          to: "/register",
          class: "learn"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Sign Up ")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("img", {
          src: pageTopPic.url,
          alt: ""
        }, null, 8, _hoisted_7)
      ])
    ]),
    _createElementVNode("div", {
      class: "bottom",
      style: _normalizeStyle(tabRef.value === 'tab2' && 'height:1008px')
    }, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (handleChangeTab(`tab1`))),
          class: _normalizeClass(["tab1", tabRef.value === 'tab1' && 'active'])
        }, _toDisplayString(pageTopPic.tabs[0]?.title), 3),
        _createElementVNode("div", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (handleChangeTab(`tab2`))),
          class: _normalizeClass(["tab2", tabRef.value === 'tab2' && 'active'])
        }, _toDisplayString(pageTopPic.tabs[1]?.title), 3)
      ]),
      (tabRef.value === 'tab1')
        ? (_openBlock(), _createBlock(Business, { key: 0 }))
        : (_openBlock(), _createBlock(Treated, { key: 1 }))
    ], 4)
  ]))
}
}

})